import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {updateUserAttribute, type UpdateUserAttributeOutput} from "aws-amplify/auth";
import {AuthenticationService} from "../../services/authentication.service";
import {ToastService} from "../../core/notifications/toast-service";
import {FormsModule} from "@angular/forms";
import {SpotfightUser} from "../../core/models/models";

import {UserService} from "../../services/user.service";

@Component({
  selector: 'app-settings',
  imports: [
    FormsModule
],
  templateUrl: './settings.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './settings.component.scss'
})
export class SettingsComponent implements OnInit {
  userForm = {
    newsletter: true
  };

  user: SpotfightUser | null = null;

  constructor(private authService: AuthenticationService,
              private userService: UserService,
              private toastService: ToastService,) {
  }

  ngOnInit(): void {
    this.user = this.authService.getUser();
  }

  onUserFormSubmit(): void {
    this.handleUpdateUserAttribute(this.userForm.newsletter)
  }

  async handleUpdateUserAttribute(newsletter: boolean) {
    try {
      const attributeKey = "custom:newsletter";
      const value = newsletter.toString();
      const output = await updateUserAttribute({
        userAttribute: {
          attributeKey,
          value
        }
      });
      this.handleUpdateUserAttributeNextSteps(output);
    } catch (error) {
      this.toastService.showDanger("User konnte nicht gespeichert werden!")
    }
  }

  handleUpdateUserAttributeNextSteps(output: UpdateUserAttributeOutput) {
    const {nextStep} = output;

    switch (nextStep.updateAttributeStep) {
      case 'CONFIRM_ATTRIBUTE_WITH_CODE':
        const codeDeliveryDetails = nextStep.codeDeliveryDetails;
        this.toastService.showDanger("Unerwarteter Fehler. An Tobi wenden.")
        break;
      case 'DONE':
        this.toastService.showSuccess("User erfolgreich gespeichert!")
        break;
    }
  }

  unlinkAll(): void {
    if (this.user?.is_patreon || this.user?.is_youtube_member) {
      this.userService.unlinkUser()
        .then(updatedUser => {
          this.authService.refreshUserState();
          this.toastService.showSuccess("Verknüpfungen erfolgreich entfernt.");
        })
        .catch((error) => {
          this.toastService.showDanger("Verknüpfungen konnten nicht entfernt werden.");
        })
    }




  }


}
